import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Pipe({
  name: 'raceLengthFormat'
})
export class RaceLengthFormatPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) {
  }

  transform(length: number | string | undefined, activeLang: string, unit?: "km" | "m" | undefined, withUnit: boolean = true): string | undefined {
    if (length !== undefined && length !== null && typeof Number(length) === "number") {
      return this.getRaceLength(Number(length), activeLang, unit, withUnit);
    }
    return "";
  }

  getRaceLength(length: number | undefined, activeLang: string, unit?: "km" | "m" | undefined, withUnit: boolean = true): string {
    let raceLength: string = "";
    if (length && (length! > 999 || unit === "km")) {
      raceLength = this.decimalPipe.transform((length! / 1000).toFixed(1), '1.0-1', activeLang) + (withUnit ? " km" : "");
    } else if (length && (length <= 999 || unit === "m")) {
      raceLength = this.decimalPipe.transform(length, '1.0-1', activeLang) + (withUnit ? " m" : "");
    }
    return raceLength;
  }

}
